module.exports = __webpack_public_path__ + "img/503.fba867fe.svg";